import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { AppShell } from "./shell/AppShell";
import { MfaPflichtBanner } from "./mfa/MfaPflichtBanner";

export function Layout() {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--color-bg)" }}>
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full animate-pulse-dot" style={{ background: "var(--color-primary)" }} />
          <span className="text-sm" style={{ color: "var(--color-muted)" }}>Laden…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.forcePasswordChange && location.pathname !== "/hub/konto") {
    return <Navigate to="/hub/konto" replace state={{ forcePasswordChange: true }} />;
  }

  return (
    <>
      <AppShell />
      <MfaPflichtBanner hinweis={user?.mfaPflicht} />
    </>
  );
}
